import { render, staticRenderFns } from "./ReasonModal.vue?vue&type=template&id=151ce516&scoped=true&"
import script from "./ReasonModal.vue?vue&type=script&lang=js&"
export * from "./ReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./ReasonModal.vue?vue&type=style&index=0&id=151ce516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ce516",
  null
  
)

export default component.exports